import { theme } from 'gradoo-theme'
import prevColor from 'gradoo-theme/lib/color/light'

const combinedTheme = {
  ...theme,
  prevColor
}

export { combinedTheme as theme }
